// eslint-disable-next-line @typescript-eslint/no-explicit-any -- heterogeneous event payloads require any[] to remain callable with any argument type
type EventCallback = (...args: any[]) => void;
export class EventEmitter {
    private events: { [key: string]: EventCallback[]; } = {};

    on(event: string, listener: EventCallback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- event arguments must remain untyped to allow emitting any payload type
    emit(event: string, ...args: any[]) {
        if (this.events[event]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- event callbacks are typed as any[] to support arbitrary event payloads
            this.events[event].forEach((listener) => listener(...args));
        }
    }
}
